import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CalcSection from './CalcSection'
import CalcParagraph from './CalcParagraph'
import NavBtn from './NavBtn'
import NavBar from './NavBar'
import DynamicGrowForm from '../forms/DynamicGrowForm'

/**
 * Smart component for rendering Section 3 of the calculator
 */
export default class Section3 extends Component {
  /**
   *
   */
  render () {
    return (
      <CalcSection title={this.props.title}>
        <CalcParagraph>
          We've covered the basics, the extras and now it's time for the fun
          stuff: financial freedom! This section covers the big ticket items
          that would be really nice to be able to afford in retirement but
          perhaps seem like a stretch for your budget. Don't worry about being
          able to afford it - this is the time to dream! The way this works is
          that we'll calculate the basics, the extras and the freedom elements
          separately so you know what it would look like to achieve each one.{' '}
        </CalcParagraph>
        <CalcParagraph>
          This is where it is all about your preferences. Some people may dream
          of traveling when they retire, some may choose to golf five days a
          week, and some may wish to give $1,000 a month to their church or
          favorite charity. The point is, this is all about a few big things
          that you would love to be able to have or do in retirement.
        </CalcParagraph>
        <CalcParagraph>
          Below, enter the name of the item in the first input and the monthly
          cost of that item in the second. Select the + icon to create another
          line item. As before, if it is easier to calculate annual cost, do
          that and divide by twelve and do not adjust for inflation over time.
        </CalcParagraph>
        <DynamicGrowForm
          reduxFormLinesKey='section3FormLines'
          sectionNumber={3}
        />
        <NavBar>
          <NavBtn nextSection={2} back />
          <NavBtn nextSection={4} />
        </NavBar>
      </CalcSection>
    )
  }
}

CalcSection.propTypes = {
  title: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/Section3MonthlyCosts.js